import React from 'react';

export interface AuthStepIndicatorProps {
  labels: readonly string[];
  currentStep: number;
  onStepClick: (step: number) => void;
}

export function AuthStepIndicator({
  labels,
  currentStep,
  onStepClick,
}: AuthStepIndicatorProps) {
  return (
    <div className="auth-steps" role="tablist" aria-label="Form progress">
      {labels.map((label, index) => {
        const stepNumber = index + 1;
        const isActive = currentStep === stepNumber;
        const isComplete = currentStep > stepNumber;
        const className = [
          'auth-step',
          isActive ? 'auth-step--active' : '',
          isComplete ? 'auth-step--complete' : '',
        ]
          .filter(Boolean)
          .join(' ');

        return (
          <button
            key={label}
            type="button"
            role="tab"
            className={className}
            aria-selected={isActive}
            aria-current={isActive ? 'step' : undefined}
            onClick={() => onStepClick(stepNumber)}
          >
            {stepNumber}. {label}
          </button>
        );
      })}
    </div>
  );
}

export default AuthStepIndicator;
